import React from 'react';
import ConnectGithubAccountForm from '../../../containers/ConnectGithubAccountForm';
import GithubPromoInfo from '../../settings/GithubPromoInfo/GithubPromoInfo';
import BillingTileHeader from '../BillingTileHeader/BillingTileHeader';

class BillingConnectToGithub extends React.Component {

    render() {
        const { githubLogin } = this.props;
        return <div className="billing-connect-to-github">
            <BillingTileHeader>Add Free Interactions<i className="icon icon-alan-help-sign" title="After free interactions are spent, you must add funds to your Alan AI Studio balance." /></BillingTileHeader>
            <ol className="billing-connect-to-github_text">
                {!githubLogin &&
                    <li>
                        <ConnectGithubAccountForm mode="link" />
                    </li>}
                <li>Go to <b><a href="https://github.com/alan-ai" target="_blank" rel="noreferrer">Github</a></b> and star our projects to get free interactions</li>
                {githubLogin && <GithubPromoInfo />}
            </ol>
        </div>;
    }
}

export default BillingConnectToGithub;
